import React from "react";
import styles from "../../_css/Home.module.css";
import { HOME_DATA_HERO } from "../../data/staticDataHome";
import { useSelector } from "react-redux";

const GuidedSessionCard = () => {
  const lang = useSelector((state) => state.language.lang);
  const { mainTitle, subTitle } = HOME_DATA_HERO[lang];

  return (
    <div className={styles.cardContainer}>
      <div className={`${styles.textSection} ${lang === "ar" ? styles.textSection : ""}`}>
        <h2 className={styles.titleHero} style={{textAlign: lang === "ar" && "left" }}>
        
          {mainTitle}{"  "}
    { lang != "ar" && <br />}
          {subTitle}
        </h2>
      </div>
      <div style={{
        left: lang === "ar" ? "0" : "auto",
        right: lang === "ar" ? "auto" : "0",
      }} className={styles.imageSection}>
        {/* <img
          src={`${process.env.REACT_APP_PROJECT_URL}/img/dr-salah-hero.jpg`}
          alt="Salah Al Rashed"
          className={`${styles.cardImage} ${styles.cardImageDesktop}`}
        />
        <img
          src={`${process.env.REACT_APP_PROJECT_URL}/img/askSalahLoginPage.jpg`}
          alt="Salah Al Rashed"
          className={`${styles.cardImage} ${styles.cardImageMobile}`}
        /> */}
      </div>
    </div>
  );
};

export default GuidedSessionCard;
